import * as tslib_1 from "tslib";
import { OpCodes } from "./OpCodes";
import { ResourceBaseFlash } from "./ResourceBaseFlash";
var IndexBufferFlash = (function (_super) {
    tslib_1.__extends(IndexBufferFlash, _super);
    function IndexBufferFlash(context, numIndices) {
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._numIndices = numIndices;
        _this._context.addStream(String.fromCharCode(OpCodes.initIndexBuffer, numIndices + OpCodes.intMask));
        _this._pId = _this._context.execute();
        _this._context._iAddResource(_this);
        return _this;
    }
    IndexBufferFlash.prototype.uploadFromArray = function (data, startOffset, count) {
        this._context.addStream(String.fromCharCode(OpCodes.uploadArrayIndexBuffer, this._pId + OpCodes.intMask) + data.join() + "#" + startOffset + "," + count + ",");
        this._context.execute();
    };
    IndexBufferFlash.prototype.uploadFromByteArray = function (data, startOffset, count) {
    };
    IndexBufferFlash.prototype.dispose = function () {
        this._context.addStream(String.fromCharCode(OpCodes.disposeIndexBuffer, this._pId + OpCodes.intMask));
        this._context.execute();
        this._context._iRemoveResource(this);
        this._context = null;
    };
    Object.defineProperty(IndexBufferFlash.prototype, "numIndices", {
        get: function () {
            return this._numIndices;
        },
        enumerable: true,
        configurable: true
    });
    return IndexBufferFlash;
}(ResourceBaseFlash));
export { IndexBufferFlash };



// WEBPACK FOOTER //
// ../dist/lib/flash/IndexBufferFlash.js